import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import { useTranslation } from "../hooks/useTranslation";
import CustomText from "./CustomText";

const Toggler = ({
  selectedSex,
  setSelectedSex,
}: {
  selectedSex: "male" | "female" | "both";
  setSelectedSex: (sex: "male" | "female" | "both") => void;
}) => {
  const { getTranslation } = useTranslation();

  return (
    <View style={styles.togglerContainer}>
      <TouchableOpacity
        style={[
          styles.togglerButton,
          selectedSex === "female" && styles.togglerButtonSelected,
        ]}
        onPress={() => setSelectedSex("female")}
      >
        <CustomText
          style={[
            styles.togglerText,
            selectedSex === "female" && styles.togglerTextSelected,
          ]}
        >
          ♀ {getTranslation("ID_FEMALE")}
        </CustomText>
      </TouchableOpacity>
      <TouchableOpacity
        style={[
          styles.togglerButton,
          selectedSex === "male" && styles.togglerButtonSelected,
        ]}
        onPress={() => setSelectedSex("male")}
      >
        <CustomText
          style={[
            styles.togglerText,
            selectedSex === "male" && styles.togglerTextSelected,
          ]}
        >
          ♂ {getTranslation("ID_MALE")}
        </CustomText>
      </TouchableOpacity>
      <TouchableOpacity
        style={[
          styles.togglerButton,
          selectedSex === "both" && styles.togglerButtonSelected,
        ]}
        onPress={() => setSelectedSex("both")}
      >
        <CustomText
          style={[
            styles.togglerText,
            selectedSex === "both" && styles.togglerTextSelected,
          ]}
        >
          ⚥ {getTranslation("ID_BOTH")}
        </CustomText>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  togglerContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginBottom: 20,
  },
  togglerButton: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 5,
    backgroundColor: "#f9f9f9",
  },
  togglerButtonSelected: {
    backgroundColor: "#007BFF",
    borderColor: "#007BFF",
  },
  togglerText: {
    fontSize: 16,
    color: "#333",
  },
  togglerTextSelected: {
    color: "#fff",
    fontWeight: "bold",
  },
});

export default Toggler;
